// Mock data for Aquavera corporate website

export const mockInsights = [
  {
    id: '1',
    title: 'Navigating Market Entry into Singapore: A Strategic Guide',
    excerpt: 'Singapore continues to be the gateway to Asia. Understanding the regulatory landscape, business culture, and strategic partnerships is crucial for successful market entry.',
    category: 'Market Entry',
    date: '2025-01-15',
    readTime: '5 min read',
    author: 'Aquavera Advisory Team'
  },
  {
    id: '2',
    title: 'Cross-Border Growth Strategies for DeepTech Companies',
    excerpt: 'DeepTech companies face unique challenges when expanding internationally. Learn how strategic partnerships and ecosystem connections can accelerate growth.',
    category: 'DeepTech',
    date: '2025-01-08',
    readTime: '7 min read',
    author: 'Aquavera Advisory Team'
  },
  {
    id: '3',
    title: 'Healthcare Innovation: Expanding from US to Asian Markets',
    excerpt: 'The Asian healthcare market presents tremendous opportunities. Discover key considerations for US healthcare companies entering the region.',
    category: 'Healthcare',
    date: '2024-12-20',
    readTime: '6 min read',
    author: 'Aquavera Advisory Team'
  },
  {
    id: '4',
    title: 'AI Companies: Strategic Partnerships in Southeast Asia',
    excerpt: 'Artificial Intelligence adoption is accelerating across Asia. Learn how to identify the right partners and navigate the complex ecosystem.',
    category: 'Artificial Intelligence',
    date: '2024-12-10',
    readTime: '8 min read',
    author: 'Aquavera Advisory Team'
  },
  {
    id: '5',
    title: 'Capital Introduction: Connecting with Asian Investors',
    excerpt: 'Understanding the investment landscape in Asia is critical. We explore how to effectively engage with family offices and institutional investors.',
    category: 'Capital',
    date: '2024-11-28',
    readTime: '5 min read',
    author: 'Aquavera Advisory Team'
  },
  {
    id: '6',
    title: 'Advanced Manufacturing: Building Supply Chain Resilience',
    excerpt: 'Supply chain diversification and regional manufacturing hubs are reshaping global manufacturing. Strategic insights for manufacturers expanding in Asia.',
    category: 'Manufacturing',
    date: '2024-11-15',
    readTime: '6 min read',
    author: 'Aquavera Advisory Team'
  }
];

export const mockContactSubmissions = [];

export const addContactSubmission = (submission) => {
  const newSubmission = {
    ...submission,
    id: Date.now().toString(),
    submittedAt: new Date().toISOString()
  };
  mockContactSubmissions.push(newSubmission);
  return newSubmission;
};
